import React from 'react'

import { createRoot } from 'react-dom/client'

import { App } from './App'

import './index.css'

let container: HTMLElement | null = null

// https://stackoverflow.com/a/72139826/11661273
document.addEventListener('DOMContentLoaded', () => {
  if (!container) {
    container = document.getElementById('root') as HTMLElement
    const root = createRoot(container)
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )
  }
})
